<h4>{{ conflictTitleKeys[conflict.type] | localize }}</h4>
<p>{{ conflictDescriptionKeys[conflict.type] | localize }}</p>

<div class="item-row" *ngFor="let g of conflict.goals.items; trackBy: trackById">
  <span>
    <span><i [uiTooltipTitle]="'objective' | localize" ui-icon ui-tooltip uiTheme="fill" uiType="goal"></i> {{ g.name }}</span>
    <ui-assignee-avatar-group uiSize="xs">
      <ui-assignee-avatar *ngFor="let assigneeId of g.ownerIds" [fromAssigneeId]="assigneeId" />
    </ui-assignee-avatar-group>
  </span>

  <a
    [uiParams]="{ id: g.id, planningSessionId: g.sessionId, openingState: 'edit' }"
    uiSref="gtmhub.goals.all._goalSidebar.goal"
    ui-button
    uiSize="default"
    uiType="primary"
    uiShape="round"
    target="_blank"
    >{{ "edit" | localize }}</a
  >
</div>

<div class="item-row" *ngFor="let m of conflict.metrics.items; trackBy: trackById">
  <span>
    <span><i [uiTooltipTitle]="'metric' | localize" ui-icon ui-tooltip uiTheme="fill" uiType="metric"></i> {{ m.name }}</span>
    <ui-assignee-avatar-group uiSize="xs">
      <ui-assignee-avatar *ngFor="let assigneeId of m.ownerIds" [fromAssigneeId]="assigneeId" />
    </ui-assignee-avatar-group>
  </span>

  <a
    [uiParams]="{ id: m.goalId, planningSessionId: sessionId, metricId: m.id }"
    uiSref="gtmhub.goals.all._goalSidebar.goal._editMetric.editMetric"
    ui-button
    uiSize="default"
    uiType="primary"
    uiShape="round"
    target="_blank"
    >{{ "edit" | localize }}</a
  >
</div>

<div class="item-row" *ngFor="let s of conflict.sessions.items; trackBy: trackById">
  <span><i [uiTooltipTitle]="'session' | localize" ui-icon ui-tooltip uiTheme="fill" uiType="session"></i> {{ s.title }}</span>

  <a [uiParams]="{ id: s.id }" uiSref="gtmhub.sessions._form.form" ui-button uiSize="default" uiType="primary" uiShape="round" target="_blank">{{ "edit" | localize }}</a>
</div>
